import { PersonalIdentityType } from './PersonalIdentityType';

export interface PersonalIdentity {
  identityType: PersonalIdentityType;
  customerId: string;
  passportNumber: string;
}

/**
 * The one identifier the customer chose, with the other blanked. The form keeps the value of
 * the hidden field as well — typed before switching the option, or prefilled from an earlier
 * visit — and the backend prefers the ID number over the passport, so passing both on would
 * book a passport holder under whatever ID number happened to be left in the form.
 */
export function selectedIdentity(identity: PersonalIdentity): Pick<PersonalIdentity, 'customerId' | 'passportNumber'> {
  return {
    customerId: identity.identityType === PersonalIdentityType.CustomerId ? identity.customerId ?? '' : '',
    passportNumber: identity.identityType === PersonalIdentityType.PassportNumber ? identity.passportNumber ?? '' : '',
  };
}
